import React from 'react';
import { User } from 'lucide-react';
import { SectionReveal, StaggerContainer, StaggerItem } from './SectionReveal';
export function DifferentialSection() {
  const audience = ['No necesitás conocimientos previos.', 'No necesitás herramientas especiales.', 'No necesitás experiencia mecánica.', 'Apto para conductores principiantes.', 'Apto para dueños de vehículos usados.'];
  return <section className="py-20 md:py-32 bg-[#0a0a0a] border-b border-[#262626]" data-id="element-45">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-46">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-47">
          <SectionReveal data-id="element-48">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-49">
              Diseñado Para{' '}
              <span className="text-[#F59E0B]" data-id="element-50">Personas Comunes</span>
            </h2>
            <p className="text-xl text-[#9CA3AF] mb-8" data-id="element-51">
              Este material fue creado para:
            </p>

            <div className="p-6 border-l-4 border-[#F59E0B] bg-[#171717] rounded-r-sm" data-id="element-52">
              <p className="text-lg text-white font-medium leading-relaxed" data-id="element-53">
                Todo está explicado paso a paso y en lenguaje simple para
                cualquier conductor.
              </p>
            </div>
          </SectionReveal>

          <StaggerContainer className="space-y-4" data-id="element-54">
            {audience.map((item, idx) => <StaggerItem key={idx} className="flex items-center gap-4 p-5 bg-[#171717] border border-[#262626] rounded-sm" data-id="element-55">
                <div className="p-2 bg-[#0a0a0a] rounded-full border border-[#262626]" data-id="element-56">
                  <User className="w-5 h-5 text-[#F59E0B]" data-id="element-57" />
                </div>
                <span className="text-lg text-[#F5F5F5] font-medium" data-id="element-58">
                  {item}
                </span>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </div>
    </section>;
}